import { ListEntryApiResponseObj } from '@brighterion/types/listEntry';
import { TFunction } from 'i18next';
import _ from 'lodash';
import { configService, DateService } from 'Services';
import { getCustomUserName } from 'Utils';

export function getConfigListType(t: TFunction, listEntry: ListManagementApiList) {
    const configCustomListTypes = configService.customListTypes;

    if (listEntry?.customListType) {
        const configListObj = configCustomListTypes?.find(
            (o: any) => o.customListType === listEntry.customListType?.listType
        );

        if (configListObj) {
            return configListObj.nameToDisplay;
        }
    }

    const configListObj = configCustomListTypes?.find((o: any) => o.customListType === listEntry.listType);

    if (configListObj) {
        return configListObj.nameToDisplay;
    }

    return t(`listTypes.${listEntry.listType}`, listEntry.listType);
}

export const addFormattedProperty = (t: TFunction, users?: UsersHashmap) => (listEntry: ListManagementApiList) => {
    return {
        ...listEntry,
        _formatted: {
            listType: getConfigListType(t, listEntry),
            createdAt: DateService.getDateTime(listEntry.createdAt) ?? listEntry.createdAt,
            modifiedAt: DateService.getDateTime(listEntry.modifiedAt) ?? listEntry.modifiedAt,
            stringId: String(listEntry.id),
            createdBy: getCustomUserName(listEntry.createdBy, users),
            activeListEntriesCount: parseInt(listEntry.activeListEntriesCount, 10),
            inactiveListEntriesCount: parseInt(listEntry.inactiveListEntriesCount, 10),
            linkedRulesCount: _.uniq([...(listEntry.deployedRules || []), ...(listEntry.sandboxRules || [])]).length
        }
    };
};

export const addFormattedPropertyEntry = (t: TFunction, users?: UsersHashmap) => (
    listEntry: ListEntryApiResponseObj
) => {
    return {
        ...listEntry,
        _formatted: {
            createdAt: DateService.getDateTime(listEntry.createdAt),
            modifiedAt: DateService.getDateTime(listEntry.modifiedAt),
            modifiedBy: getCustomUserName(listEntry.modifiedBy, users),
            removedAt: DateService.getDateTime(listEntry.removedAt),
            removedBy: getCustomUserName(listEntry.removedBy, users),
            startTime: DateService.getDateTime(listEntry.startTime),
            endTime: DateService.getDateTime(listEntry.endTime),
            merchantId: listEntry?.merchantId === '' ? t('All Merchants') : listEntry?.merchantId,
            status: t(
                listEntry.endTime &&
                    new Date() >= new Date(listEntry.endTime) &&
                    new Date(listEntry.removedAt) >= new Date(listEntry.endTime)
                    ? 'Expired'
                    : 'Deleted'
            )
        }
    };
};

export const getListIdHashMap = (listData: ListManagementApiList[]) => {
    const hm: ListManagementApiListIdHashMap = {};

    listData.forEach((list) => {
        hm[list.id] = { ...list };
    });

    return hm;
};
